import {ChangeDetectionStrategy, Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {TransactionsService} from '../../../services/transactions/transactions.service';
import {TeamsService} from '../../../services/teams/teams.service';
import {MatTableDataSource} from '@angular/material/table';
import {IBankTransactionInterface, ITransactionInterface} from './peer-to-peer-transaction.interface';
import {ITeamUserInterface} from '../../../interfaces/user/user.interface';
import { IP2pParsedJsonInterface } from '../analytics-reimbursements/transactions.interface';
import { TeamMember } from '../../../interfaces/team/member/member.interface';

@Component({
  selector: 'app-analytics-peer-to-peer',
  templateUrl: './analytics-peer-to-peer.component.html',
  styleUrls: ['./analytics-peer-to-peer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnalyticsPeerToPeerComponent implements OnInit {
  @Input() analytics: any;
  @ViewChild(MatSort) sort!: MatSort;
  public columnsToDisplay: string[] = ['transactionDate', 'recipient', 'sender', 'description', 'amount', 'category', 'taxable', 'status'];
  private teamId = '';
  public userId = 'all';
  public transactionList: MatTableDataSource<ITransactionInterface> = new MatTableDataSource<ITransactionInterface>([]);
  protected isLoading = true;

  constructor(
      private transactionService: TransactionsService,
      private teamService: TeamsService
  ) {}

  async ngOnInit(): Promise<void> {
    this.teamService.wellspaceChangedObservable.subscribe((team: any): void => {
      if (team && team.id) {
        this.teamId = team.id;
      }
      this.transactionList.data = [];
      this.getAllPeerToPeerTransactions();
    });
  }

  async getAllPeerToPeerTransactions(): Promise<void> {
    console.log('Getting all peer transactions');
    try {
      const listOfTransactionsP2p = await this.transactionService.getTeamPeerToPeerTransactions(this.teamId, 'P2p');
      const teamMembers: TeamMember[] =  await this.teamService.getTeamMembers(this.teamId);
      const p2pTransactionsFromTransactionsTable = await this.transactionService.getPeerToPeerTeamTransactionHistory(this.teamId);
      const formattedNewTransactions = this.formatNewTransactions(p2pTransactionsFromTransactionsTable, teamMembers);
      listOfTransactionsP2p.push(...formattedNewTransactions);
      listOfTransactionsP2p.sort((a, b) => new Date(b.transactionDate).getTime() - new Date(a.transactionDate).getTime());
      this.transactionList.data = listOfTransactionsP2p;
      this.isLoading = false;
    } catch (error) {
      console.error(`Error in list Reimbursements in get all peer to peer transaction: ${error}`);
      this.transactionList.data = [];
      this.isLoading = false;
    }
  }

  formatNewTransactions(transactions: IBankTransactionInterface[], teamMembers: TeamMember[]): ITransactionInterface[] {
    const formattedTransactions: ITransactionInterface[] = [];
    for (const transaction of transactions) {
      const parsedJSON: IP2pParsedJsonInterface = JSON.parse(transaction.sourceData);
      const recipient = teamMembers.find(teamMember => teamMember.userId === parsedJSON.destinationUserId || teamMember.memberId === parsedJSON.destinationUserId);
      const sender = teamMembers.find(teamMember => teamMember.userId === parsedJSON.fromUserId || teamMember.memberId === parsedJSON.fromUserId);
      const formattedTransaction: ITransactionInterface = {
        transactionDate: transaction.createdAt,
        amount: transaction.amount,
        category: JSON.parse(parsedJSON.extraInfo.categories),
        description: 'P2P Transaction',
        recipient: !recipient ? '---' : `${recipient.firstName} ${recipient.lastName ?? ''}`,
        sender: !sender ? '---' : `${sender.firstName} ${sender.lastName ?? ''}`,
        status: transaction.transactionType,
        taxable: false,
      };
      formattedTransactions.push(formattedTransaction);
    }
    return formattedTransactions;
  }
}
